import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPagelessShareTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PAGELESS_SHARE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_REPORTS_PAGELESS_SHARE;

	get id(): string {
		return TourId.REPORTS__PAGELESS_SHARE;
	}

	override get keyForPersistantDone(): string {
		return ReportsPagelessShareTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					// Target the Share button in the header
					return $('#report-editor_head .share-link');
				},
				scrollToAttachTo: true,
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		// User manually closed - mark all pageless tours as done
		this.flowTourReportsPagelessService.endAllTours();
		super.onExplicitClose();
	}
}
